"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clicksink = void 0;
function getCellValue(row, cell, value, columnDef, data, grid) {
    if (columnDef.displayMember) {
        value = data[columnDef.displayMember];
    }
    return value == null ? '' : value;
}
function clicksink() {
    const clicksinkFormatter = (row, cell, value, columnDef, data, grid) => {
        return `<a href='#' onclick='return false;'>
  ${getCellValue(row, cell, value, columnDef, data, grid)}
</a>`;
    };
    clicksinkFormatter.exportRawData = true;
    return clicksinkFormatter;
}
exports.clicksink = clicksink;
//# sourceMappingURL=clicksink.js.map